export default __webpack_public_path__ + "static/media/sticker-6.e37cea96.png";